export default "__VITE_ASSET__15115b0a__"